import { NgModule } from '@angular/core';
import { Component, OnInit, OnDestroy, ViewChild, ElementRef } from '@angular/core';
import { TamasAlunoService } from '../tamas-aluno.service';
import { Router, ActivatedRoute } from '@angular/router';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA, MAT_DATE_LOCALE, DateAdapter, MAT_DATE_FORMATS } from '@angular/material';
import { AlertaSimplesDialog } from '../alerta-simples';
import { AlertaInputDialog } from '../alerta-input';
import { AlertaConfirmDialog } from '../alerta-confirm';
import { Location } from '@angular/common';
import { AlertaTermosDialog } from '../alerta-termos';
import { FormControl } from '@angular/forms';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import * as moment from 'moment';


// export const MY_FORMATS = {
//   parse: {
//       dateInput: 'LL'
//   },
//   display: {
//       dateInput: 'YYYY-MM-DD',
//       monthYearLabel: 'YYYY',
//       dateA11yLabel: 'LL',
//       monthYearA11yLabel: 'YYYY'
//   }
// };

@Component({
  selector: 'app-dashboard-novoplano',
  templateUrl: './dashboard-novoplano.component.html',
  styleUrls: ['./dashboard-novoplano.component.css']
})
export class DashboardNovoplanoComponent implements OnInit {
  hideLoginLoad: boolean = true;
  meusDados: any = '';
  dadosRecuperar: any = '';
  tentativasFail: any = 0;
  isPassword: boolean = true;
  idCliente: any = 0;
  fcmToken: any = '';
  idPaciente: any = '';
  dataRetorno: string;
  dataInicio: string;
  dataTermino: string;
  dataInicioPA: string;
  dataPicked: Date;
  dataPickedIni: Date;
  dataPickedI: Date;
  dataPickedT: Date
  titPlano: any = '';
  qTipoPlano: any = '';
  public maskNascimento = [/[0-9]/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/];
  public maskTelefone = ['(', /[1-9]/, /\d/, ')', ' ', /\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
  listaMacros: any[] = [];
  filteredOptions: Observable<string[]>;
  myControl = new FormControl();
  tipotreino: any = '';
  escolherMacro: boolean = false;
  escolherMeso: boolean = false;
  escolherCapTreino: boolean = false;
  nomemacro: any = '';
  nomemesociclo: any = '';
  existeRetorno: boolean = false;
  dataHj: any = '';
  capacidadetreino: any = '';
  metodotreino: any = '';
  arrMetodosT: any[] = [];
  exibePickM: boolean = false;
  listaMesos: any[] = [];
  txtpmacro: any = '';
  constructor(private route: ActivatedRoute, public tmaService: TamasAlunoService, public router: Router, public dialog: MatDialog, private _location: Location) { }

  ngOnInit() {
    //this.tmaService.eventoFS(true);
    this.tmaService.eventoFS(false);
    this.idPaciente = this.route.snapshot.paramMap.get('idpaciente');
    this.dataRetorno = "Escolher uma data";
    this.dataInicio = "Escolher data";
    this.dataTermino = "Escolher data";
    this.dataInicioPA = "Escolher data";
    // this.listaMacros.push({Id: 1, nome: 'Macrociclo 1'});
    // this.listaMacros.push({Id: 2, nome: 'Macrociclo 2'});
    this.dataHj = moment(new Date()).format("DD/MM/YYYY");
    this.filteredOptions = this.myControl.valueChanges
      .pipe(
        startWith(''),
        map(value => this._filter(value))
      );
    this.obterListasIni();
  }
  ngOnDestroy() {
    console.log("destroy");
    //this.tmaService.eventoFS(false);
  }

  private _filter(value: string): string[] {
    console.log("filtrar");
    console.log(value);
    const filterValue = value.toLowerCase();
    return this.listaMacros.filter(option => option.NomeMacro.toLowerCase().includes(filterValue));
  }

  tooManyalerts(mensagem: string): void {
    const avisoLogar = this.dialog.open(AlertaSimplesDialog, {
      // width: '250px',
      disableClose: true,
      data: { iconAlerta: 'warning', tituloAlerta: 'AVISO', textoAlerta: mensagem }
    });
  }

  obterListasIni(): void {
    this.hideLoginLoad = false;
    var dadosIn = 'email=' + this.tmaService.hcEmail + '&senha=' + this.tmaService.hcSenha + '&idpaciente=' + this.idPaciente;
    this.tmaService.getInfoMrMs(dadosIn)
      .subscribe((qRes) => {
        console.log(qRes);
        this.hideLoginLoad = true;
        if (qRes['res'] == 'ok') {
          this.listaMacros = qRes['objMacro'];
          this.listaMesos = qRes['objMeso'];
          if(this.listaMacros.length > 0){
            this.txtpmacro = 'Escolha o macrociclo';
          }
          else{
            this.txtpmacro = 'Nome do macrociclo';
          }
        }
        else {
          const avisoIC = this.dialog.open(AlertaConfirmDialog, {
            // width: '250px',
            disableClose: true,
            data: { tituloAlerta: "Aviso", textoAlerta: "Ocorreu um erro ao carregar as informações. Tente novamente", textoConfirm: "OK" }
          });
          avisoIC.afterClosed().subscribe((result) => {
            this.voltar();
          });
        }
      },
        (error) => {
          this.hideLoginLoad = true;
          const avisoErro = this.dialog.open(AlertaConfirmDialog, {
            // width: '250px',
            disableClose: true,
            data: { tituloAlerta: "Aviso", textoAlerta: "Verifique sua conexão com a internet. Tente novamente",  textoConfirm: "OK" }
          });
          avisoErro.afterClosed().subscribe((result) => {
            this.voltar();
          });
        });
  }

  goPlano(): void {
    if (this.qTipoPlano == '') {
      this.tooManyalerts("Você deve escolher o <b>Tipo de Plano</b> para continuar!");
      console.log(this.dataPicked);
    }
    else {
      //server side


      //após criar o plano, redireciona para a página de adição dos itens de acordo com o tipo
      //retornar id do novo plano
      if (this.qTipoPlano == 'Alimentar') {
        if (this.titPlano == '') {
          this.tooManyalerts("Por favor dê um nome para este plano");
          return;
        }

        if (this.dataPickedIni == undefined) {
          this.tooManyalerts("Por favor escolha uma data de início para o plano ");
          return;
        }

        if (this.dataPicked == undefined) {
          this.tooManyalerts("Por favor escolha uma data de término para o plano ");
          return;
        }

        let customParams = {
          //lista: localStorage.getItem('turboCart'),
          email: this.tmaService.hcEmail,
          senha: this.tmaService.hcSenha,
          idpaciente: this.idPaciente,
          titplano: this.titPlano,
          dataretorno: this.dataRetorno,
          datainicio : this.dataInicioPA
        };
        this.hideLoginLoad = false;
        this.tmaService.criarNovoPlanoAli(customParams).subscribe((qRes) => {
          this.hideLoginLoad = true;
          console.log(qRes);
          if (qRes['res'] == 'ok') {
            this.router.navigate(['dashboard/refeicao/' + this.idPaciente + '/' + qRes['idplano']]);
          }
          else {
            const erroCriar = this.dialog.open(AlertaSimplesDialog, {
              disableClose: true,
              data: { textoAlerta: "Ocorreu um erro ao criar este plano. Tente novamente", iconAlerta: 'warning' }
            });
          }
        },
          (error) => {
            this.hideLoginLoad = true;
            const erroCriar = this.dialog.open(AlertaSimplesDialog, {
              disableClose: true,
              data: { textoAlerta: "Verifique sua conexão com a internet. Tente novamente", iconAlerta: 'warning' }
            });
          })

        //this.router.navigate(['dashboard/add-refeicao/' + this.nickPaciente + '/1']);

      }
      else {
        console.log(this.listaMacros.find(x => x.NomeMacro == this.nomemacro));
        var isNovoMacro = false;
        var qIdMeso = 0;
        if (this.tipotreino == '') {
          this.tooManyalerts("Por favor escolha a categoria do treino");
          return;
        }

        if (this.tipotreino == 'Mesociclo') {
          if (this.nomemacro == '') {
            this.tooManyalerts("Por favor escolha um macrociclo ou crie um novo digitando um nome para ele");
            return;
          }
        }
        console.log(this.nomemesociclo);
        if (this.tipotreino == 'Microciclo') {
          if (this.nomemesociclo == '') {
            this.tooManyalerts("Por favor escolha um mesociclo");
            return;
          }
          else {
            //qIdMeso = this.listaMesos.find(x => x.Id == this.nomemesociclo).Id;
            qIdMeso = this.nomemesociclo;
          }
        }

        if (this.listaMacros.find(x => x.NomeMacro == this.nomemacro) == undefined) {
          isNovoMacro = true;
        }
        else {
          isNovoMacro = false;
        }

        if (this.titPlano == '') {
          this.tooManyalerts("Por favor dê um nome para este plano");
          return;
        }


        if (this.capacidadetreino == '') {
          this.tooManyalerts("Por favor escolha a <b>capacidade física<b> deste treino");
          return;
        }

        if (this.capacidadetreino == 1) {
          if (this.metodotreino == '') {
            this.tooManyalerts("Por favor escolha o <b>método<b> deste treinamento");
            return;
          }
        }

        // if (this.tipotreino == 'Microciclo') {
        //   if (this.dataPickedI == undefined) {
        //     this.tooManyalerts("Por favor escolha uma <b>data inicial<b> para este microciclo");
        //     return;
        //   }
        //   if (this.dataPickedT == undefined) {
        //     this.tooManyalerts("Por favor escolha uma <b>data de término<b> para este microciclo");
        //     return;
        //   }
        // }
        // else {
        //   if (this.dataPicked == undefined) {
        //     this.tooManyalerts("Por favor escolha uma data de retorno ");
        //     return;
        //   }
        // }

        if (this.dataPickedIni == undefined) {
          this.tooManyalerts("Por favor escolha uma data de início para o plano ");
          return;
        }

        if (this.dataPicked == undefined) {
          this.tooManyalerts("Por favor escolha uma data de término para o plano ");
          return;
        }

        //server
        let customParams = {
          //lista: localStorage.getItem('turboCart'),
          email: this.tmaService.hcEmail,
          senha: this.tmaService.hcSenha,
          idpaciente: this.idPaciente,
          categoria: this.tipotreino,
          nomemacro: this.nomemacro,
          idmeso: qIdMeso,
          novomacro: isNovoMacro,
          capacidadef: this.capacidadetreino,
          metodot: this.metodotreino,
          titplano: this.titPlano,
          dataini: this.dataInicioPA,
          dataend: this.dataRetorno
        };
        this.hideLoginLoad = false;
        this.tmaService.criarNovoPlanoExc(customParams).subscribe((qRes) => {
          this.hideLoginLoad = true;
          console.log(qRes);
          if (qRes['res'] == 'ok') {
            this.router.navigate(['dashboard/add-treino/' + this.idPaciente + '/' + qRes['idficha']]);
          }
          else {
            const erroCriar = this.dialog.open(AlertaSimplesDialog, {
              disableClose: true,
              data: { textoAlerta: "Ocorreu um erro ao criar este plano. Tente novamente", iconAlerta: 'warning' }
            });
          }
        },
          (error) => {
            this.hideLoginLoad = true;
            const erroCriar = this.dialog.open(AlertaSimplesDialog, {
              disableClose: true,
              data: { textoAlerta: "Verifique sua conexão com a internet. Tente novamente", iconAlerta: 'warning' }
            });
          })

        //this.router.navigate(['dashboard/add-treino/' + this.idPaciente + '/1']);
      }

    }


  }
  pickTipoT(qEvent: any): void {
    console.log(qEvent);
    console.log(this.tipotreino);
    if (this.tipotreino == 'Mesociclo') {
      this.escolherMeso = false;
      this.escolherMacro = true;
      this.existeRetorno = true;
    }
    else {
      if (this.listaMesos.length == 0) {
        //não há mesos, não pode criar um micro sem meso
        this.tipotreino = 'Mesociclo';
        this.escolherMeso = false;
        this.escolherMacro = true;
        this.existeRetorno = true;
        this.tooManyalerts("Não foram encontrados mesosciclos! Crie primeiro um mesociclo para depois criar os <b>microciclos</b> ");
        
      }
      else{
        this.escolherMeso = true;
        this.escolherMacro = false;
        this.existeRetorno = false;
      }
    
    }

  }

  pickCapacidade(qEvent: any): void {
    if (qEvent.value == 1) {
      this.exibePickM = true;
      this.arrMetodosT = [];
      this.arrMetodosT.push({ nome: 'Contínuo' }, { nome: 'Intermitente' });
    }
    else {
      this.exibePickM = false;
    }
  }

  pickTipoPlano(qEvent: any): void {
    this.existeRetorno = true;
    if (this.qTipoPlano == 'Treino') {
      this.escolherCapTreino = true;
    }
    else {
      this.escolherCapTreino = false;
    }
  }
  dataSelecionada(): void {
    console.log("foi");
    console.log(this.dataPicked);
    if (this.dataPicked !== undefined && this.dataPicked !== null) {
      console.log(this.dataPicked);
      this.dataRetorno = this.dataPicked.toLocaleDateString();
      console.log(this.dataRetorno.replace(/\//g, '-'));
      var dataFormatada = this.dataRetorno.replace(/\//g, '-');
      //this.router.navigate(['/me/cardapio/' + this.meuIdDieta + '/' + this.dataPicked.getDay() + '/' + dataFormatada]);
      //this.router.navigate(['/dashboard/consultas/' + dataFormatada]);
    }
  }
  dataSelecionadaIn(): void {
    console.log("foi");
    console.log(this.dataPickedIni);
    if (this.dataPickedIni !== undefined && this.dataPickedIni !== null) {
      console.log(this.dataPickedIni);
      this.dataInicioPA = this.dataPickedIni.toLocaleDateString();
    }
  }

  dataSelecionadaI(): void {
    console.log("foi");
    console.log(this.dataPickedI);
    if (this.dataPickedI !== undefined && this.dataPickedI !== null) {
      console.log(this.dataPickedI);
      this.dataInicio = this.dataPickedI.toLocaleDateString();
      console.log(this.dataInicio.replace(/\//g, '-'));
      //var dataFormatada = this.dataRetorno.replace(/\//g,'-');
      //this.router.navigate(['/me/cardapio/' + this.meuIdDieta + '/' + this.dataPicked.getDay() + '/' + dataFormatada]);
      //this.router.navigate(['/dashboard/consultas/' + dataFormatada]);
    }
  }
  dataSelecionadaT(): void {
    console.log("foi");
    console.log(this.dataPickedT);
    if (this.dataPickedT !== undefined && this.dataPickedT !== null) {
      console.log(this.dataPickedT);
      this.dataTermino = this.dataPickedT.toLocaleDateString();
      console.log(this.dataTermino.replace(/\//g, '-'));
      //var dataFormatada = this.dataRetorno.replace(/\//g,'-');
      //this.router.navigate(['/me/cardapio/' + this.meuIdDieta + '/' + this.dataPicked.getDay() + '/' + dataFormatada]);
      //this.router.navigate(['/dashboard/consultas/' + dataFormatada]);
    }
  }

  voltar(): void {
    //this._location.back();
    this.router.navigate(['/dashboard/paciente/' + this.idPaciente]);

  }

}